const normalizeSearchText = (value: string) => value
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLocaleLowerCase('es')
  .trim();

export function matchesChatTitle(title: string, search: string) {
  const normalizedTitle = normalizeSearchText(title);
  return normalizeSearchText(search).split(/\s+/).filter(Boolean)
    .every((word) => normalizedTitle.includes(word));
}
